export default __webpack_public_path__ + "static/media/pfsense.4b3eaa01.png";